/* eslint-disable import/no-cycle */
import { InjectionKey } from 'vue';
import { createStore, Store, useStore as baseUseStore } from 'vuex';

import general from '@/store/modules/general';
import liveEditor from '@/store/modules/live-editor';
import { State } from '@/types';
import statsEditor from '@/store/modules/stats-editor';
import listImportEditor from '@/store/modules/list-import-editor';
import dataViewer from '@/store/modules/data-viewer';
import choosePlan from '@/store/modules/choose-plan';
import templateEditor from '@/store/modules/template-editor';
import dataExplorer from '@/store/modules/data-explorer';
import segmentationsEditor from '@/store/modules/segmentations-editor';
import customObject from '@/store/modules/custom-object';
import flowEditor from '@/store/modules/flow-editor';
import billing from '@/store/modules/billing';

export const key: InjectionKey<Store<State>> = Symbol('store-key');

// Plugin pour surveiller uniquement le state du module customObject
const customObjectWatcher = (store: any) => {
  store.subscribe((mutation: any, state: any) => {
    // FOR DEBUGGING ONLY
    if (mutation.type.startsWith('customObject/')) {
      // console.log('🔄 [CustomObject State Watcher]', JSON.parse(JSON.stringify(state.customObject)));
    }
  });
};

export const store = createStore<State>({
  modules: {
    general,
    liveEditor,
    statsEditor,
    listImportEditor,
    dataViewer,
    choosePlan,
    templateEditor,
    dataExplorer,
    segmentationsEditor,
    customObject,
    flowEditor,
    billing,
  },
  plugins: [customObjectWatcher],
});

export function useStore() {
  return baseUseStore(key);
}
